// @ts-nocheck
import React from 'react';
import {
  deleteBackgroundTemplateMutation,
  backgroundTemplatesQuery,
} from 'graphql/admin/backgrounds';
import {
  CopyIcon,
  ListView,
  TableContainer as TableContainer2,
} from 'routes/admin/style';
// import ApiList from 'components/grid/api-list';
// import Table from 'components/grid/table';
import LogoutMenu from 'routes/admin/components/logout-menu';
// import DateField from 'components/grid/table/components/fields/date-field';
import Button from 'components/button';
import { useTranslation } from 'i18n';
import { useHistory } from 'react-router';
import { WithMargin } from 'components/layout';
// import { copyToClipboard } from 'utils/js';
// import toast from 'services/toast';

import styled from 'styled-components';
import { DeleteIcon } from 'routes/surface/components/link-context-menu/style';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';

const StyledImg = styled.img`
  height: 100px;
  width: 100px;
`;

const StyledText = styled.div`
  height: 100px;
  width: 600px;
`;

const StyledText2 = styled.div`
  height: 100px;
  width: 150px;
`;

function AdminBackgroundList({ location }) {
  const { t } = useTranslation();
  const history = useHistory();

  //console.log("XXXXX", location.search)

  const itemData = [
    // {
    //   url: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Rufzeichen_rot.png',
    //   title: 'Rufzeichen Rot',
    //   id:"",
    // },
    {
      id: '',
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Pro_Contra.png',
      title: 'Pro und Contra',
      description:
        '1) Erstellen Sie Elemente als Argumente FüR oder GEGEN eine Maßfnahme.\n(2) Ziehen Sie diese in den jeweiligen Bereich\n    (3) Teilen Sie die Zelle um die Meinung aller zur Umsetzung notwenigen Personen zu sammeln ',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Plan_A_Plan_B_Plan_C.png',
      title: 'Plan A,  Plan B,  Plan C',
      description:
        'Ziehen Sie Elemente als Argumente für einen Plan (=Varainte) in den jeweiligen Bereich.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_1.jpg',
      title: 'Design Cortlex 1',
      description:
        'Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_2.jpg',
      title: 'Design Cortlex 2',
      description:
        'Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_3.png',
      title: 'Design Cortlex 3',
      description:
        'Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_Cortlex_4.png',
      title: 'Design Cortlex 4',
      description:
        'Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_5.png',
      title: 'Design Cortlex 5',
      description:
        'Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Fokus.png',
      title: 'Fokus',
      description:
        'Die wichtigsten Elemente sammeln Sie hier in der Mitte, die weniger wichtigen eher am Rand.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/My_TO_Dos.png',
      title: 'Todos',
      description:
        'Erstellen Sie Post-Ist mit Ihren TO DOs und ziehen Sie diese in die Zeilen.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Ga_steliste.png',
      title: 'Gästelist',
      description:
        'Fügen Sie die Namen der Gästeste als Textfeld hinzu und ziehen Sie diese in den Bereich Zusage, offen oder Absage.\nTeilen Sie die Zelle mit allen anderen Beteiligten!',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Kalender_2022.png',
      title: ' Kalender',
      description:
        'Fügen sie den Kalender 2022 hinzu und positionieren Sie die Elemente an der passenden Stelle.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Decision-Matrix.png',
      title: 'Decision Matrix',
      description:
        'Halten Sie eine neue Aufgaben auf einem Post-It fest und ziehen Sie diese je nach Wichtigkeit und Dringlichkeit in den entsprechenden Bereich. So arbeiten Sie effektiver und effizienter.',
    },

    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Siegertreppchen.png',
      title: 'Siegertreppchen',
      description:
        'Fügen Sie dieses Siegertreppchen hinzu um die Top 3 von mehreren möglichen Entscheidung optisch hervorgehoben darzustellen.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Next_Steps.png',
      title: 'Next Steps',
      description:
        '(1) Erstellen Sie zunächst Post-Its mit den nächsten Schritten.\n(2) Laden Sie Bilder von den Personen hoch, denen Sie Aufgaben zuweisen möchten.\nAlternativ können Sie auch Textfelder mit den Namen erstellen.\n(3) Teilen Sie die Zelle mit denjenigen Personen.',
    },
    {
      url:
        'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Rufzeichen_rot.png',
      title: 'Rufzeichen Rot',
      description:
        'Fügen Sie dieses Rufzeichen hinzu um einen besonders wichtigen Bereich zu markieren.',
    },
  ];

  const { data, loading, error, refetch } = useQuery(backgroundTemplatesQuery, {
    // skip: isLoginOrRegisterPage,
    fetchPolicy: 'network-only',
  });

  // const { dataDelete, loadingDelete, errorDelete } = signInCodesQuery, {
  //   // skip: isLoginOrRegisterPage,
  //   fetchPolicy: 'network-only',
  // });

  console.log(' XXX ', data);

  const deleteEntry = async (row) => {
    console.log('DELET ', row);
    try {
      await deleteBackgroundTemplateMutation({ id: row.id });
      refetch();
      toast.success('Gelöscht');
    } catch (error) {
      console.log('ERROR');
    }
  };

  return (
    <ListView>
      <LogoutMenu />
      <WithMargin bottom="40px">
        <Button
          label={t('Create Background')}
          onClick={() => history.push('/admin/background/form')}
        />
      </WithMargin>
      <TableContainer2>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell align="center">Image</TableCell>
                <TableCell align="center">Description</TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell> */}
                {/* <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.backgrounds?.nodes?.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell align="center">{row.title}</TableCell>
                  <TableCell align="center">
                    {' '}
                    <StyledImg src={row.url}></StyledImg>
                  </TableCell>
                  <TableCell align="left">
                    {' '}
                    <StyledText>{row.description}</StyledText>
                  </TableCell>
                  {/* <TableCell align="center" > Bearbeiten</TableCell> */}
                  <TableCell align="center" onClick={() => deleteEntry(row)}>
                    {' '}
                    Löschen
                  </TableCell>
                  {/* <TableCell align="right">{row.protein}</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </TableContainer2>
    </ListView>
  );
}

export default AdminBackgroundList;

/*

<ApiList query={signInCodesQuery} filter={{}}>
<Table>

<Table.Field label={t('Title')} name="title" bold > 

{({ data }) => {
    return <StyledText2>{data.title}</StyledText2>;
  }}
</Table.Field>

<Table.Field
  label={t('Background')}
  name="url"
  // onClick={(event, code) => {
  //   window.open(
  //     window.location.origin + '/register?code=' + code,
  //     '_blank',
  //   );
  // }}
  >
  {({ data }) => {
    return <StyledImg src={data.url}></StyledImg>;
  }}
</Table.Field>
<Table.Field label={t('Description')} name="title" 
>
                {({ data }) => {
    return <StyledText>{data.description}</StyledText>;
  }}
   </Table.Field>

<Table.Action
  label=" "
  icon={<CopyIcon />}
  onClick={(data) => {
    try {
      copyToClipboard(
        window.location.origin + '/register?code=' + data.code,
      );
      toast.success(t('Successfully copied to clipboard'));
    } catch (error) {
      toast.success(t('Something went wrong'));
    }
  }}
 /> 

<Table.Action
  label=" "
  icon={<DeleteIcon />}
  onClick={(data) => {
    try {
      copyToClipboard(
        window.location.origin + '/register?code=' + data.code,
      );
      toast.success(t('Successfully copied to clipboard'));
    } catch (error) {
      toast.success(t('Something went wrong'));
    }
  }}
 /> 

</Table>
<ApiList.Pagination />
</ApiList>

*/
